var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"pagetop",staticClass:"ma-0 pa-0",staticStyle:{"height":"calc(100vh - 100px)"},attrs:{"fluid":""}},[(_vm.loadIframe)?_c('iframe',{staticStyle:{"height":"100%","width":"100%","border":"0"},attrs:{"src":_vm.portalUrl,"border":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }